import { NavLink } from 'react-router-dom';
import { T } from '../../../../../../Translations';
import { GroupResource } from '../../../../../../GroupsStore/Types';

export interface Props {
  resource: GroupResource;
}

function Edit({ resource }: Props) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <NavLink
      to={`/people/groups/${resource.payload.id}/edit`}
      state={{ returnUrl: '/people/groups' }}
      className="px-2 py-1 block w-full cursor-pointer"
      onClick={handleClick}
      data-intercom-target="edit-group-action"
    >
      <T kind="Edit" />
    </NavLink>
  );
}

export default Edit;
